

import { Overlay } from '@angular/cdk/overlay';
import { Injectable, Injector, TemplateRef } from '@angular/core';

import { MwcSingletonService } from 'mwc/core/services';

import { MwcMNService } from './base';
import { MwcMessageContainerComponent } from './message-container.component';
import { MwcMessageServiceModule } from './message.service.module';
import { MwcMessageData, MwcMessageDataOptions, MwcMessageRef } from './typings';

@Injectable({
  providedIn: MwcMessageServiceModule
})
export class MwcMessageService extends MwcMNService {
  protected override container?: MwcMessageContainerComponent;
  protected componentPrefix = 'message-';

  constructor(mwcSingletonService: MwcSingletonService, overlay: Overlay, injector: Injector) {
    super(mwcSingletonService, overlay, injector);
  }

  success(content: string | TemplateRef<void>, options?: MwcMessageDataOptions): MwcMessageRef {
    return this.createInstance({ type: 'success', content }, options);
  }

  error(content: string | TemplateRef<void>, options?: MwcMessageDataOptions): MwcMessageRef {
    return this.createInstance({ type: 'error', content }, options);
  }

  info(content: string | TemplateRef<void>, options?: MwcMessageDataOptions): MwcMessageRef {
    return this.createInstance({ type: 'info', content }, options);
  }

  warning(content: string | TemplateRef<void>, options?: MwcMessageDataOptions): MwcMessageRef {
    return this.createInstance({ type: 'warning', content }, options);
  }

  loading(content: string | TemplateRef<void>, options?: MwcMessageDataOptions): MwcMessageRef {
    return this.createInstance({ type: 'loading', content }, options);
  }

  create(
    type: 'success' | 'info' | 'warning' | 'error' | 'loading' | string,
    content: string | TemplateRef<void>,
    options?: MwcMessageDataOptions
  ): MwcMessageRef {
    return this.createInstance({ type, content }, options);
  }

  private createInstance(message: MwcMessageData, options?: MwcMessageDataOptions): MwcMessageRef {
    this.container = this.withContainer(MwcMessageContainerComponent);

    return this.container.create({
      ...message,
      ...{
        createdAt: new Date(),
        messageId: this.getInstanceId(),
        options
      }
    });
  }
}
